// extracted by mini-css-extract-plugin
export default {"square":"letter_square__TfzcZ","letter":"letter_letter__7tzNx","selected":"letter_selected__dZ7h7","value":"letter_value__VXcab","point":"letter_point__ePJj+"};